
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconHistorySelector = "fhi-icon-history";

/**
 * ## FhiIconHistory
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-history
 * @element fhi-icon-history
 */
@customElement(FhiIconHistorySelector)
export class FhiIconHistory extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M12 2.25A9.751 9.751 0 1 1 2.25 12a.75.75 0 0 1 1.5 0 8.25 8.25 0 1 0 8.251-8.25 9 9 0 0 0-6.22 2.53l-.97.97H8a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 8V3a.75.75 0 0 1 1.5 0v3.19l.988-.989a10.5 10.5 0 0 1 7.26-2.951zm0 4a.75.75 0 0 1 .75.75v4.536l3.585 1.793a.75.75 0 0 1-.67 1.342l-4-2A.75.75 0 0 1 11.25 12V7a.75.75 0 0 1 .75-.75"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
